import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { environment } from 'src/environments/environment';
import { AppVersionGridParams, AppVersionListingModel } from 'common/models/page-models/App Version Model/app-version-grid.model';
import { AppVersionModel } from 'common/models/page-models/App Version Model/app-version-form-model';



@Injectable({
    providedIn: 'root'
})
export class AppVersionGridDataService extends GridDataService<AppVersionListingModel, AppVersionModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.appManagementGetall, http, ss);
    }

    createInstance(): AppVersionListingModel {
        return new AppVersionListingModel();
    }
    override getGridParams(params): GridPostParams {
        return new AppVersionGridParams()
    }
    override getDeleteUrl(): string {
        throw new Error('Method not implemented.');
    }

    override getExtraParam() {
        return 'details';
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, 'details');
        // console.log("APIRES before filtering and transformation", apiRes, param);
    
        if (apiRes && apiRes.details && Array.isArray(apiRes.details)) {
            apiRes.details = apiRes.details.map((detail: any) => {
                const transformedDetail: any = {};
                Object.keys(detail).forEach((key) => {
                    let value = detail[key];
                    if (typeof value === 'string') {
                        if (value.toLowerCase() === 'android') {
                            // Capitalize only the first letter of "android"
                            value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
                        } else {
                            // Fully capitalize all other strings
                            value = value.toUpperCase();
                        }
                    }
                    transformedDetail[key] = value;
                });
                return transformedDetail;
            });
        }
    
        // console.log("APIRES after transformation", apiRes);
        return apiRes;
    }
    
    
    
    
    postLoginData(data, url: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiService
                .postData(url, data)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

}